"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthLink = void 0;
const apollo_link_context_1 = require("apollo-link-context");
const createAuthLink = (tokenService) => {
    if (!tokenService) {
        throw new Error('Cannot make AuthLink, no instance of TokenService was provided');
    }
    return apollo_link_context_1.setContext((_, { headers }) => {
        // get the authentication token if it exists
        const token = tokenService.getToken();
        // return the headers to the context so httpLink can read them
        return {
            headers: Object.assign(Object.assign({}, headers), { authorization: token ? `Bearer ${token}` : '' }),
        };
    });
};
exports.createAuthLink = createAuthLink;
//# sourceMappingURL=createAuthLink.js.map